import * as yup from "yup";
import { createValidationSchema, validate } from "@";

export const classificationsSchema = createValidationSchema({
  Name: validate("req", "name"),
  Order: validate("number", "Order"),
  IsActive: yup.boolean().default(true),
  ShowOnHomePage: yup.boolean().default(true),
  ShowOnFastDonation: yup.boolean().default(true),
});

export const classificationsDefaultValues = {
  id: null,
  Order: 0,
  Name: null,
  Image: null,
  Banner: null,
  IsActive: true,
  imageFullUrl: null,
  bannerFullUrl: null,
  ShowOnHomePage: true,
  ShowOnFastDonation: true,
};
